import { api, endpoints } from "../api";
import { AxiosPromise } from "axios";
import { BaseApiPaging } from "api/types";

const fetch = (skip: number, take: number, filter?: string, orderBy?: string): AxiosPromise<BaseApiPaging<UserApi>> => {
  return api.get<BaseApiPaging<UserApi>>(endpoints.ADMIN_USERS.GET(skip, take, filter, orderBy));
};

const fetchById = (userId: number): AxiosPromise<UserApi> => {
  return api.get<UserApi>(endpoints.ADMIN_USERS.GET_BY_ID(userId));
};

export const usersApi = {
  fetch,
  fetchById,
};

export interface UserApi {
  id: number;
  firstName: string;
  avatarPhoto?: string;
  surname: string;
  email: string;
  phone: string;
  roles: Role[];
}

export interface Role {
  id: number;
  name: string;
}
